import { ReactComponent as BottomLightSVG } from "./bottom-bg.svg"

export default BottomLightSVG